var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "free-icon-clock-3311693",
    transform: "translate(-25.924 -25.925)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1529",
    "data-name": "\\uADF8\\uB8F9 1529",
    transform: "translate(25.924 25.925)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1462",
    "data-name": "\\uD328\\uC2A4 1462",
    d: "M39.924,53.925a14,14,0,1,1,14-14A14.016,14.016,0,0,1,39.924,53.925Zm0-26.053A12.053,12.053,0,1,0,51.977,39.925,12.066,12.066,0,0,0,39.924,27.872Z",
    transform: "translate(-25.924 -25.925)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1530",
    "data-name": "\\uADF8\\uB8F9 1530",
    transform: "translate(39.472 33.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1463",
    "data-name": "\\uD328\\uC2A4 1463",
    d: "M244.937,150.156a.844.844,0,0,1-.441-.124l-4.09-2.492a.848.848,0,0,1-.407-.724v-6.022a.848.848,0,1,1,1.7,0v5.546l3.683,2.244a.848.848,0,0,1-.442,1.573Z",
    transform: "translate(-240 -139.944)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTime);
export default __webpack_public_path__ + "static/media/ico_time.0933ad84aac2c9ef9db72b042a9636a1.svg";
export { ForwardRef as ReactComponent };